import { Nullable } from '@/utils/types';
import { PipelineStageEnum, SourceEnum } from '@/bundles/Pipelines/types';
import { PropertyTypeEnum } from '@/bundles/Property/interfaces/PropertyType';
import {
  IBrokerSplitItem,
  IPipelineDashboardDealContact,
  IPipelineDashboardPipelineDetailsGetOne,
  IPipelineDashboardDealTask,
} from '@/bundles/Pipeline/types';

export default class PipelineDashboardPipelineDetailsModel implements IPipelineDashboardPipelineDetailsGetOne {
  name: Nullable<string>;
  logo: Nullable<string>;
  stage: PipelineStageEnum;
  probability: Nullable<number>;
  company_name: Nullable<string>;
  property_type: PropertyTypeEnum;
  transaction_category: Nullable<string>;
  source: Nullable<SourceEnum>;
  size: Nullable<number>;
  land_size: Nullable<number>;
  financials_consideration: Nullable<number>;
  commission: Nullable<number>;
  commission_per: Nullable<number>;
  commission_total: Nullable<number>;
  close_date: Nullable<string>;
  is_close_date_estimated: Nullable<boolean>;
  days_open: Nullable<number>;
  contacts: IPipelineDashboardDealContact[];
  tasks: IPipelineDashboardDealTask[];
  broker_splits: IBrokerSplitItem[];

  constructor (payload: IPipelineDashboardPipelineDetailsGetOne) {
    this.name = payload.name;
    this.logo = payload.logo;
    this.stage = payload.stage;
    this.probability = payload.probability;
    this.company_name = payload.company_name;
    this.property_type = payload.property_type;
    this.transaction_category = payload.transaction_category;
    this.source = payload.source;
    this.size = payload.size;
    this.land_size = payload.land_size;
    this.financials_consideration = payload.financials_consideration;
    this.commission = payload.commission;
    this.commission_per = payload.commission_per;
    this.commission_total = payload.commission_total;
    this.close_date = payload.close_date;
    this.is_close_date_estimated = payload.is_close_date_estimated;
    this.days_open = payload.days_open;
    this.contacts = payload.contacts ?? [];
    this.tasks = payload.tasks ?? [];
    this.broker_splits = payload.broker_splits ?? [];
  }
}
